export const BE_ALLOWED_GROUP_FUNCTIONS: ReadonlyArray<string> = ['FLD', 'FLD_HME', 'OSH'];
